import { FC } from 'react';
import Page, { PageProps } from '../../components/page';
import { Box } from '@mui/material';
import DataTable from '../../components/data-table';
import PageHeader from '../../components/page/header';
import { AdminRoleLabels } from '../../lib/models/admin-user.model';
import Text from '../../components/text';
import Button from '../../components/button';
import { DtColumn, DtFilter, DtPage } from '@/components/data-table/helpers';
import { getAdminUsers } from '@/lib/services/admin-user.service';
import OpenDrawerButton from '@/components/drawers/open-drawer-button';
import { QueryKey } from '@/lib/query-client';
import DomSize from '@/components/dom-size';
import PageBlurb from '@/components/page/blurb';
import PageTools from '@/components/page/tools';
import useDrawer from '@/hooks/use-drawer.hook';

const columns: DtColumn[] = [
  { name: 'name', label: 'Name', flex: 2, sortable: true },
  { name: 'email', label: 'Email', flex: 3, sortable: true },
  { name: 'role', label: 'Role', sortable: true },
  { name: 'action', label: '', sortable: false },
];

const AdminUsersPage: FC<PageProps> = () => {
  const { openDrawer } = useDrawer();

  const handleView = (userId?: string) => {
    openDrawer('admin-user', {
      id: userId || null,
    });
  };

  const loadData = async (pageParams: DtPage, filter?: DtFilter) => {
    const { page, pageSize, sort } = pageParams;
    const dataset = await getAdminUsers(page, pageSize, sort, filter);

    return {
      ...dataset,
      rows: dataset.rows.map(({ id, name, email, role }) => {
        return {
          id,
          name: <Box maxWidth="100%">{name}</Box>,
          email,
          role: <Text size="small">{AdminRoleLabels[role]}</Text>,
          action: <OpenDrawerButton onClick={() => handleView(id)} />,
        };
      }),
    };
  };

  return (
    <Page title="Admin Users">
      <PageHeader>
        <PageBlurb>
          Create new admin users, and view and change permissions for existing users.
        </PageBlurb>
        <PageTools>
          <Button label="Add Admin User" icon="plus" size="small" onClick={() => handleView()} />
        </PageTools>
      </PageHeader>
      <DomSize>
        <DataTable
          queryKey={QueryKey.AdminUsersDataset}
          columns={columns}
          onLoad={loadData}
          search
          searchPlaceholder="Search by name or email"
          sort={{ columnName: 'name', direction: 'asc' }}
        />
      </DomSize>
    </Page>
  );
};

export default AdminUsersPage;
